import { connect, Dispatch } from 'react-redux';
import { IRootState } from 'redux/root_reducer';

import BrandInfo, { DispatchProps, StateProps } from 'components/pages/brand/BrandInfo';

import {  BrandInfoAction, sendDataRequest, sendInstrumentDataRequest, sendInstrumentWithModelDataRequest, sendModelsDataRequest, setPerPage } from 'redux/modules/brand-info';

const mapStateToProps = (state: IRootState): StateProps => {
    return {
        brandContent: state.brandInfo.brandContent,
        brandDefaultYear: state.brandInfo.brandDefaultYear,
        brandImageUrl: state.brandInfo.brandImageUrl,
        brandInstruments: state.brandInfo.brandInstruments,
        brandMetaDesc : state.brandInfo.brandMetaDesc,
        brandMetaTitle: state.brandInfo.brandMetaTitle,
        brandModel: state.brandInfo.brandModel,
        brandModels: state.brandInfo.brandModels,
        brandName: state.brandInfo.brandName,
        brandPager: state.brandInfo.brandPager,
        brandTitle: state.brandInfo.brandTitle,
        fetchFailed: state.brandInfo.failed,
        fetching: state.brandInfo.fetching,
        isMobile: state.display.isMobile
    };
};

const mapDispatchToProps = (dispatch: Dispatch<BrandInfoAction>): DispatchProps => {
    return {
        loadBrandInfo: (brandName: string) => dispatch<any>(sendDataRequest(brandName)),
        loadBrandInstrumentsInfo: (brandName: string, brandYear: string, page: string) => dispatch<any>(sendInstrumentDataRequest(brandName, brandYear, page)),
        loadBrandInstrumentsWithModelInfo: (brandName: string, brandModel: string, brandYear: string, page: string) => dispatch<any>(sendInstrumentWithModelDataRequest(brandName, brandModel, brandYear, page)),
        loadBrandModelsInfo: (brandName: string, brandYear: string) => dispatch<any>(sendModelsDataRequest(brandName, brandYear)),
        setPerPage: (perPage: string) => dispatch<any>(setPerPage(perPage))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BrandInfo);



// WEBPACK FOOTER //
// ./src/containers/pages/brand/BrandInfo.tsx